<button mat-dialog-close type="button" mat-icon-button aria-label="close dialog" tabindex="-1">
  <mdb-icon fas icon="times" [size]="size"></mdb-icon>
</button>
